import { MenuItem } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import {
  markProjectAsComplete,
  submitDeliverables,
  updateProject,
} from '../../../actions/projectActions'
import { ProjectStatus } from './ProjectHeader'

const ProjectHeaderStatusItem = ({ close, status, setShowArchiveModal }) => {
  const dispatch = useDispatch()

  const { project } = useSelector((state) => state.projectDetails)
  const { userInfo } = useSelector((state) => state.userLogin)

  const handleClick = () => {
    const projectClone = { ...project, status }

    if (status === ProjectStatus.PENDING_ACCEPTANCE) {
      dispatch(submitDeliverables(projectClone))
    } else if (status === ProjectStatus.COMPLETE) {
      dispatch(markProjectAsComplete(projectClone))
    } else if (status === ProjectStatus.ARCHIVED) {
      setShowArchiveModal(true)
    } else {
      dispatch(updateProject(projectClone))
    }

    close()
  }

  const isDisabled = () => {
    let disabled = true

    if (
      status === ProjectStatus.IN_PROGRESS &&
      project.status === ProjectStatus.PENDING_ACCEPTANCE
    ) {
      disabled = false
    }

    if (
      status === ProjectStatus.PENDING_ACCEPTANCE &&
      project.status === ProjectStatus.IN_PROGRESS
    ) {
      disabled = false
    }

    if (
      (status === ProjectStatus.PENDING_ACCEPTANCE ||
        status === ProjectStatus.IN_PROGRESS) &&
      project.status === ProjectStatus.COMPLETE
    ) {
      disabled = false
    }

    if (userInfo.role === 'Manager' || userInfo.role === 'Support') {
      disabled = false
    }

    return disabled
  }

  return (
    <MenuItem
      disabled={isDisabled()}
      className={project.status === status ? 'active' : ''}
      onClick={handleClick}
    >
      {status}
    </MenuItem>
  )
}

export default ProjectHeaderStatusItem
